<div
  *ngIf="!loading"
  class="px-3 pt-2 pb-4">
  <div
    class="overflow-y-auto overflow-x-hidden"
    style="max-height: 90vh">
    <p class="font-medium text-2xl">
      Для дальнейшей работы вам необходимо экспортировать данные из системы 1С в сервис ФРМ.
    </p>

    <p class="font-medium text-2xl">Следуйте указаниям инструкции, представленной ниже</p>

    <div class="mt-4">
      <div class="relative">
        <div
          *ngIf="isShowBackButton"
          class="absolute top-0 left-0 h-full w-15rem cursor-pointer block-back-image"
          style="z-index: 100"
          (click)="backImage()">
          <div class="flex align-items-center justify-content-start h-full cursor-pointer">
            <i
              class="pi pi-angle-double-left text-green-500 hover:text-green-300 cursor-pointer ml-6 icon-back-image"
              style="font-size: 3rem; z-index: 100"></i>
          </div>
        </div>

        <crm-image
          [src]="activeImage.src"
          [alt]="activeImage.alt"
          height="500px"
          width="100%"
          styleClass="w-full"
          appendTo="body"></crm-image>

        <div
          *ngIf="isShowNextButton"
          class="absolute top-0 right-0 h-full w-15rem cursor-pointer block-next-image"
          style="z-index: 100"
          (click)="nextImage()">
          <div class="flex align-items-center justify-content-end h-full cursor-pointer">
            <i
              class="pi pi-angle-double-right text-green-500 hover:text-green-300 cursor-pointer mr-6 icon-next-image"
              style="font-size: 3rem; z-index: 100"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <div
        *ngIf="!activeImage.isShowForm1C && !activeImage.isShowExtension && !activeImage.isShowNext"
        style="height: 44px"></div>

      <crm-button
        *ngIf="activeImage.isShowForm1C && !databases?.length"
        label="Заполнить реквизиты базы 1С"
        icon="pi pi-database"
        styleClass="p-button-lg"
        (onClick)="showAddDatabase()"></crm-button>

      <crm-button
        *ngIf="activeImage.isShowExtension"
        type="button"
        label="Скачать расширение"
        icon="pi pi-file"
        styleClass="p-button-success p-button-lg"
        [loading]="loadingDownload"
        (onClick)="downloadExtension()"></crm-button>

      <crm-button
        *ngIf="activeImage.isShowForm1C && databases?.length"
        label="Уже заполнено"
        icon="pi pi-check"
        styleClass="p-button-text p-button-success p-button-lg"
        [disabled]="true"></crm-button>

      <crm-button
        *ngIf="activeImage.isShowNext"
        type="button"
        label="Далее"
        icon="pi pi-arrow-right"
        iconPos="right"
        styleClass="p-button-success p-button-lg"
        (onClick)="next.emit()"></crm-button>
    </div>
  </div>
</div>
